// src/components/agent/AgentRoute.js
// Gate for /agent/* routes — must be signed in AND have status: 'active'.
// `roles` prop limits access (default: anyone with active status).
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAgentAuth } from '../../lib/auth';
import AgentLayout from './AgentLayout';

export function defaultRouteForRole(role) {
  return role === 'lead_submitter' ? '/agent/submit' : '/agent/dashboard';
}

export default function AgentRoute({ children, adminOnly = false, roles }) {
  const { user, profile, loading } = useAgentAuth();

  if (loading) {
    return (
      <div style={loadingStyle}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, color: '#6B1E2E' }}>Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/agent/login" replace />;
  if (!profile || profile.status !== 'active') return <Navigate to="/agent/pending" replace />;
  if (adminOnly && profile.role !== 'admin') return <Navigate to={defaultRouteForRole(profile.role)} replace />;
  if (Array.isArray(roles) && roles.length > 0 && !roles.includes(profile.role)) {
    return <Navigate to={defaultRouteForRole(profile.role)} replace />;
  }

  return <AgentLayout profile={profile}>{children}</AgentLayout>;
}

const loadingStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FAF7F2' };
